// Post-signup redirect hook. Pages like /try (anonymous drill) and /c/:id
// (challenge a friend) store a path in localStorage before sending the visitor
// to sign in; after a successful auth we land them back there once.
export const POST_SIGNUP_REDIRECT_KEY = 'sdl_post_signup_redirect';

/** Accept only same-origin, absolute paths ("/x"); reject "//host", "\\", full URLs. */
export function safeRedirectPath(value) {
  if (typeof value !== 'string') return null;
  const v = value.trim();
  if (!v.startsWith('/') || v.startsWith('//') || v.includes('\\')) return null;
  if (v.includes('session_id=')) return null; // would re-trigger the OAuth callback
  try {
    const url = new URL(v, window.location.origin);
    if (url.origin !== window.location.origin) return null;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
}

/** Read + clear the stored redirect. Returns a safe path or null. */
export function consumePostSignupRedirect() {
  let raw = null;
  try {
    raw = localStorage.getItem(POST_SIGNUP_REDIRECT_KEY);
    localStorage.removeItem(POST_SIGNUP_REDIRECT_KEY);
  } catch {
    return null;
  }
  return safeRedirectPath(raw);
}
